import React from 'react';
import { styles } from '../styles/styles';
import awardIcon from '../assets/why-icons/award.svg';
import calendarCheckIcon from '../assets/why-icons/calendar-check.svg';
import minnesotaIcon from '../assets/why-icons/minnesota.svg';

const iconCircle = {
  width: '112px',
  height: '112px',
  borderRadius: '50%',
  backgroundColor: 'white',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const iconImage = {
  width: '64px',
  height: '64px'
};

const WhyChooseUs = () => {
  return (
    <section style={styles.whyChooseUs}>
      <div style={styles.sectionContainer}>
        <h2 style={styles.sectionTitle}>Why Choose Metro Mowing?</h2>
        <div style={styles.whyGrid} className="why-grid">
          <div style={styles.whyCard}>
            <div style={styles.whyIcon}>
              <div style={iconCircle}>
                <img src={awardIcon} alt="" style={iconImage} />
              </div>
            </div>
            <h3 style={styles.whyTitle}>Local Experts</h3>
            <p style={styles.whyDescription}>Experienced team serving Apple Valley, Rosemount, Eagan, Burnsville and Lakeville with consistent, high-quality lawn care results.</p>
          </div>
          <div style={styles.whyCard}>
            <div style={styles.whyIcon}>
              <div style={iconCircle}>
                <img src={calendarCheckIcon} alt="" style={iconImage} />
              </div>
            </div>
            <h3 style={styles.whyTitle}>Reliable Service</h3>
            <p style={styles.whyDescription}>Dependable scheduling and consistent service you can count on week after week.</p>
          </div>
          <div style={styles.whyCard}>
            <div style={styles.whyIcon}>
              <div style={iconCircle}>
                <img src={minnesotaIcon} alt="" style={iconImage} />
              </div>
            </div>
            <h3 style={styles.whyTitle}>Minnesota Lawn Knowledge</h3>
            <p style={styles.whyDescription}>Specialized knowledge of Minnesota grass types, soil conditions, and seasonal lawn care needs.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;